<template>
  <a-modal
    :confirmLoading='confirmLoading'
    title='周期配置'
    :visible='visible'
    :width='1200'
    @cancel='handleCancel'
    @ok='handleOk'>
    <a-spin :spinning='confirmLoading'>
      <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 3 },wrapperCol: { span: 21 },}" ref="ruleForm" :rules="rules">
        <a-form-model-item  label='是否需要随访' prop='period'>
          <a-switch v-model='model.periodBl' />
        </a-form-model-item>
        <template v-if="model.periodBl">
          <a-form-model-item label='随访生成方式' prop='createType'>
            <a-radio-group v-model='model.createType' >
              <a-radio :value="item.value" :key="item.value"  v-for="item in createTypeList">
                {{item.text}}
              </a-radio>
            </a-radio-group>
          </a-form-model-item>

          <template v-if='model.createType === "1" '>
            <a-form-model-item label='随访启动设置' prop='startSet'>
              <a-radio-group v-model='model.startSet' :options="[{ label: '根据基点事件自动随访', value: '1' },{ label: '满足条件随访', value: '2' }]" />
            </a-form-model-item>
            <a-form-model-item label='手动添加周期分组' prop='groupSet'>
              <a-radio-group v-model='model.groupSet' :options="[{ label: '否', value: '0' },{ label: '是', value: '1' }]" />
              <span v-if="model.groupSet==='1'">                
                <a-button type="primary" @click="dictSearch" ><a-icon type="search" />选择分组</a-button>
                <a-input v-model='model.groupTypeName' placeholder='分组类别' readOnly style="width:180px; margin-left: 10px" />
              </span>
            </a-form-model-item>
            <a-form-model-item help='*可设置最大5个中文长度。' label='基点名称' prop='baseName'>
              <a-input v-model='model.baseName' placeholder='请输入基线名称' />
            </a-form-model-item>
            <a-form-model-item label="周期">
              <a-table :columns='columns1' :dataSource='dataSource1' :pagination='false' :scroll="{x:'800px',y:'300px'}"  rowKey='id' style="width: 100%" size='small'>
              <span slot="action" slot-scope="text, record, index">
                <a @click="deleteLine(index,dataSource1)">删除</a>
              </span>
                <span slot="sortNum" slot-scope="text, record, index">
                       <a-input-number v-model="record.sortNum" placeholder="请输入排序" :min="0" :precision="0" style="width: 100%"/>
               </span>

                <span slot="name" slot-scope="text, record, index">
                            <a-input placeholder="请输入名称" v-model="record.name" />
              </span>
                <span slot="visitId" slot-scope="text, record, index">
                  <a-select v-model="record.visitId"  placeholder="请选择" >
            <a-select-option
              v-for="item in visitList"
              :key="item.id"
              :value="item.id">
              <a-tooltip :title="item.name">
                {{ item.name }}
              </a-tooltip>
            </a-select-option>
          </a-select>
              </span>
              <span slot="buildCondition" slot-scope="text, record, index">
                  <a-select v-model="record.conditionId"  placeholder="请选择" show-search allowClear :filter-option="filterOptionTip">
                    <a-select-option
                      v-for="(item,index) in periodBuildConditionList"
                      :key="index"
                      :value="item.id">
                      <a-tooltip :title="item.description">
                        {{ item.description }}
                      </a-tooltip>
                    </a-select-option>
                  </a-select>
              </span>
                <span slot="basePointDay" slot-scope="text, record, index">
                   <a-input-number v-model="record.basePointDay" placeholder="请输入距基点天数" :min="0" :precision="0" style="width: 100%"/>
              </span>
                <span slot="advanceDay" slot-scope="text, record, index">
                  <a-input-number v-model="record.advanceDay" placeholder="请输入最大可提前天数" :min="0" :precision="0" style="width: 100%"/>
              </span>
                <span slot="delayDay" slot-scope="text, record, index">
                  <a-input-number v-model="record.delayDay" placeholder="请输入最大可延后天数" :min="0" :precision="0" style="width: 100%"/>
              </span>
                <span slot="answerUnexpired" slot-scope="text, record, index">
                  <a-switch v-model='record.answerUnexpiredBl' checked-children="是" un-checked-children="否"  />
              </span>
                <span slot="answerOverdue" slot-scope="text, record, index">
                  <a-switch v-model='record.answerOverdueBl' checked-children="是" un-checked-children="否"  />
              </span>
              <span slot="isCopy" slot-scope="text, record, index">
                  <a-switch v-model='record.isCopyBl' checked-children="是" un-checked-children="否"  />
              </span>
              <span slot="editVisitDate" slot-scope="text, record, index">
                  <a-switch v-model="record.editVisitDate" checked-children="是" un-checked-children="否"  />
              </span>
              </a-table>
              <a-button type='primary' @click='addLine(dataSource1)'>新增周期</a-button>
            </a-form-model-item>
            <a-form-model-item label='中途手动添加周期' prop='halfway'>
              <a-switch v-model='model.halfwayBl' />
            </a-form-model-item>
          </template>
          <template v-if='model.createType === "2" || model.halfwayBl  '>
            <a-form-model-item label='手动添加周期名称预设'>
              <a-table :columns='columns2' :dataSource='dataSource2' :pagination='false' :scroll="{y:'300px'}"  rowKey='id' size='small'>
              <span slot="action" slot-scope="text, record, index">
                <a @click="deleteLine(index,dataSource2)">删除</a>
              </span>
                <span slot="sortNum" slot-scope="text, record, index">
                       <a-input-number v-model="record.sortNum" placeholder="请输入排序" :min="0" :precision="0" style="width: 100%"/>
               </span>

                <span slot="name" slot-scope="text, record, index">
                            <a-input placeholder="请输入名称" v-model="record.name" />
              </span>
              </a-table>
              <a-button type='primary' @click='addLine(dataSource2)'>新增周期</a-button>
            </a-form-model-item>
          </template>
        </template>
      </a-form-model>
      <dict-search-modal ref="dictSelect" @onSelect="dictOnSelect"></dict-search-modal>
    </a-spin>
  </a-modal>
</template>

<script>
  import { getAction, postAction } from '@api/manage'
  import baseRules from '@/constants/baseRules'
  import DictSearchModal from '../element/DictSearchModal'

  export default {
    name: 'FollowUpPeriodModel',
    inject:['getVisitList'],
    components: { DictSearchModal},
    data() {
      return {
        visible: false,
        model: {},
        confirmLoading: false,
        rules: {
          createType:[baseRules.requiredChange],
          startSet:[baseRules.requiredChange],
          // baseName:[baseRules.required],
        },
        createTypeList:[{ text: '自动生成', value: '1' },{ text: '手动添加', value: '2' }],
        dataSource1:[],
        dataSource2:[],
        visitList:[],
        periodBuildConditionList:[{"id":'0',"description":"无"}],//周期启动条件，来自质疑配置规则数据
        fixedColumns: [
          {
            title: '排序',
            align: 'center',
            dataIndex: 'sortNum',
            scopedSlots: { customRender: 'sortNum' },
            width: 60
          },
          {
            title: '周期名称',
            dataIndex: 'name',
            align: 'center',
            scopedSlots: { customRender: 'name' },
            width: 150,
            ellipsis: true
          },
          {
            title: '关联事件',
            dataIndex: 'visitName',
            scopedSlots: { customRender: 'visitId' },
            width: 150,
            align: 'center'
          },
          {
            title: '距基点天数',
            dataIndex: 'basePointDay',
            scopedSlots: { customRender: 'basePointDay' },
            align: 'center',
            width: 70
          },
          {
            title: '最大可提前天数',
            dataIndex: 'advanceDay',
            scopedSlots: { customRender: 'advanceDay' },
            align: 'center',
            width: 70
          }, {
            title: '最大可延后天数',
            dataIndex: 'delayDay',
            scopedSlots: { customRender: 'delayDay' },
            align: 'center',
            width: 70
          },
          {
            title: '允许未到期作答',
            dataIndex: 'answerUnexpired_dictText',
            align: 'center',
            scopedSlots: { customRender: 'answerUnexpired' },
            width: 70,
          },
          {
            title: '允许过期作答',
            dataIndex: 'answerOverdue_dictText',
            align: 'center',
            scopedSlots: { customRender: 'answerOverdue' },
            width: 70,
          },
          {
            title: '允许复制编辑',
            dataIndex: 'isCopy_dictText',
            align: 'center',
            scopedSlots: { customRender: 'isCopy' },
            width: 60,
          },
          {
            title: '修改访视日期',
            dataIndex: 'commonFlag',
            align: 'center',   
            scopedSlots: { customRender: 'editVisitDate' },         
            width: 60,
          },     
        ],
        optColumns:[{
            title: '操作',
            align: 'center',
            width: 60,
            scopedSlots: { customRender: 'action' },
          }
        ]
      }
    },
    computed: {
      columns1() {
        let cols = []
        cols.push(...this.fixedColumns)
        if(this.model.startSet ==='2'){
          cols.push({
            title: '随访启动条件',
            dataIndex: 'conditionId',
            align: 'center',
            scopedSlots: { customRender: 'buildCondition' },
            width: 150,
          })
        }
        cols.push(...this.optColumns)
        return cols
      },
      columns2() {
        return [
          {
            title: '排序',
            align: 'center',
            dataIndex: 'sortNum',
            scopedSlots: { customRender: 'sortNum' },
            width: 80
          },
          {
            title: '预设名称',
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' },
            align: 'center',
            ellipsis: true,
            width: 200,
          },
          {
            title: '操作',
            dataIndex: '操作',
            align: 'center',
            width: 100,
            scopedSlots: { customRender: 'action' },
          }
        ]
      },
    },
    created() {
    },
    methods: {
      /**
       * 随访生成方式变化
       * @param generateWay
       */
      onChange(generateWay) {
      },
      edit(record) {
        this.visitList = this.getVisitList()
        // console.log("record:"+record)
        record = JSON.parse(JSON.stringify(record))
        record.periodBl = record.period==='1'
        record.halfwayBl = record.halfway==='1'
        record.itemList = record.itemList||[]
        const dataSource1 = []
        const dataSource2 = []
        record.itemList.forEach(item=>{
          if(item.halfway ==='0'){
            item.answerUnexpiredBl = item.answerUnexpired==='1'
            item.answerOverdueBl = item.answerOverdue==='1'
            item.isCopyBl = item.isCopy==='1'
            item.editVisitDate = (item.commonFlag & 1)===1
            dataSource1.push(item)
          }
          else if(item.halfway ==='1'){
            dataSource2.push(item)
          }

        })
        this.dataSource1 = dataSource1
        this.dataSource2 = dataSource2
        // this.dataSource1 = record.itemList.filter(item=> item.halfway ==='1')
        // this.dataSource2 = record.itemList.filter(item=> item.halfway ==='2')
        this.model = record
        this.visible = true
        this.getPeriodBuildConditionList()
      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      handleOk() {
        const that = this
        // 触发表单验证
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            let errorMsg = ''
            if(that.model.createType === "1" ){
              that.dataSource1.forEach((item,index)=>{
                item.halfway = '0'
                if(errorMsg){
                  return
                }
                if(!item.sortNum
                  || !item.name
                  || !item.visitId
                  || !(item.basePointDay!==null && item.basePointDay!==undefined)
                  || !(item.advanceDay!==null && item.advanceDay!==undefined)
                  || !(item.delayDay!==null && item.delayDay!==undefined)
                ){
                  return errorMsg = `周期：请填写完整信息，第${index+1}行`
                }
              })
            }
            if(that.model.createType === "2" || that.model.halfwayBl){
              that.dataSource2.forEach((item,index)=>{
                item.halfway = '1'
                if(errorMsg){
                  return
                }
                if(!item.sortNum
                  || !item.name
                ){
                  return errorMsg = `手动周期：请填写完整信息，第${index+1}行`
                }
              })
            }
            if(errorMsg){
              return this.$message.warning(errorMsg)
            }
            that.model.period = that.model.periodBl ? '1':'0'
            that.model.halfway = that.model.halfwayBl ? '1':'0'
            // console.log("that.model.groupSet:" + that.model.groupSet)
            if(that.model.groupSet ==='0'){
              that.model.groupType = ''
            }            
            that.dataSource1.forEach(item=>{
              item.answerUnexpired = item.answerUnexpiredBl?'1':'0'
              item.answerOverdue = item.answerOverdueBl?'1':'0'
              item.isCopy = item.isCopyBl?'1':'0'
              console.log("item.editVisitDate:"+item.editVisitDate)
              item.commonFlag = item.editVisitDate?'1':'0'
            })
            let itemList = []
            itemList = itemList.concat(that.dataSource1)
            itemList = itemList.concat(that.dataSource2)            
            if(that.model.startSet==='1'){
              itemList.forEach(item=>{
                item.conditionId = '0'
              })
            }
            that.model.itemList = itemList
            that.confirmLoading = true
            postAction('/project/projectPeriod/config', that.model).then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
                that.close()
              } else {
                that.$message.warning(res.message)
              }
            }).finally(() => {
              that.confirmLoading = false
            })
          } else {
            return false
          }
        })
      },
      handleCancel() {
        this.close()
      },

      /**
       * 新增周期(一行)
       */
      addLine(dataSource = []) {
        dataSource.push({ id: Math.random() + '' })
      },
      /**
       * 移除行
       * @param index
       * @param dataSource
       */
      deleteLine(index, dataSource = []) {
        if (index > -1) {
          dataSource.splice(index, 1)
        }
      },      
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      filterOptionTip(input, option) {
        return option.componentOptions.children[0].componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      getPeriodBuildConditionList(){
        var params = {"projectId":this.model.projectId,"pageSize":1000,"type":"3"};//查询其他规则的质疑     
        this.periodBuildConditionList=[{"id":'0',"description":"无"}]   
        getAction('/project/projectSysQuestion/list', params).then((res) => {
          if (res.success) {
            this.periodBuildConditionList.push(...(res.result.records || res.result))
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
        })
      },
      dictSearch(){
        let httpurl = '/project/projectDict/list?projectId='+this.model.projectId
        this.$refs['dictSelect'].view(httpurl)
      },
      dictOnSelect(record){
        this.model.groupType = record.id
        this.$set(this.model,'groupTypeName',record.dictName)
      },
    }
  }
</script>

<style scoped>
  /deep/ .ant-form-item {
    margin-bottom: 0px;
  }
</style>
